import { Link } from "react-router-dom"
import slugify from "slugify"
import React from "react"
import PropTypes from "prop-types"
import { Spacer } from "../atoms/Atoms"
import L10n from "../../../lib/carrot-l10n"
import { isVideo } from "components/containers/library/ReadArticleContainer"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../atoms/Bodies"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const ArticleCTALink = ({ to }) => (
  <Link
    className="black-60 dib b no-underline f7 bb b--carrot-orange-35 nowrap"
    style={{ fontSize: 13, paddingBottom: ".4375rem" }}
    to={to}
  >
    {l`client.content.readMore`}
  </Link>
)

const VideoThumbnailLink = ({ title, categorySlug, thumbnailUrl }) => (
  <Link to={`/read/${categorySlug}/${slugify(title)}`}>
    <div className="relative">
      <img className="flex flex-auto" src={thumbnailUrl} alt={title} />
      <img
        src="/images/icon-video-play-button.svg"
        alt="play"
        style={{
          position: "absolute",
          top: "calc(50% - 36px)",
          left: "calc(50% - 36px)"
        }}
      />
    </div>
  </Link>
)

const ArticlePreview = ({
  categorySlug,
  article,
  article: {
    fields: { title, slug, description, thumbnailImage }
  }
}) => (
  <div className="flex flex-column justify-between">
    <H3>
      {isVideo(article) && l`client.library.videoLabel` + " "}
      {title}
    </H3>
    {isVideo(article) ? (
      <div className="mt3">
        <VideoThumbnailLink categorySlug={categorySlug} title={title} thumbnailUrl={thumbnailImage.fields.file.url} />
      </div>
    ) : (
      <>
        <div className="mt1">
          <BodySmall color="black-60">{description}</BodySmall>
        </div>
        <Spacer height={0.5} />
        <div>
          <ArticleCTALink to={`/read/${categorySlug}/${slug ? slug : slugify(title)}`} />
        </div>
      </>
    )}
  </div>
)

ArticlePreview.propTypes = {
  article: PropTypes.object.isRequired,
  categorySlug: PropTypes.string.isRequired
}

export default ArticlePreview
